import moment from 'moment';
import CryptoJS from 'crypto-js';
import { state, formData, initFormData, mobileReg, countDownFn } from './data';
import { Toast } from 'vant';
import upload from '../upload';
import { reportsms, addreport } from './api';
const md5 = str => CryptoJS.MD5(str).toString().toLowerCase();

export default {
  getArea(areaList, areaCode) {
    const column = [];
    if (!areaCode) {
      return column;
    }
    for (let i = 0; i < 3; i++) {
      let code = areaCode.slice(0, (i + 1) * 2);
      let type = 'county_list';

      switch (i) {
        case 0:
          type = 'province_list';
          code = code + '0000';
          break;
        case 1:
          type = 'city_list';
          code = code + '00';
          break;
      }
      const name = areaList[type][code];
      if (name) {
        column.push({
          name,
          code
        });
      }
    }
    return column.filter(item => item.code);
  },
  sendSMS() {
    const tel = formData.tel;
    if (!mobileReg.test(tel)) {
      Toast.fail('请输入正确的手机号码');
      return;
    }
    reportsms(tel).then(() => {
      countDownFn(state.complainSMS);
    });
  },
  onSubmit(value) {
    // if (!value.type) {
    //   Toast.fail('请选择举报类型');
    //   return;
    // }
    const files = value.file.map(item => item.filepath);
    const data = Object.assign({}, value, {
      file: files.join(','),
      area_code: formData.area_code
    });
    delete data.area_name;
    // const requiredFields = ['report_theme'];
    Object.keys(data).forEach(key => {
      if (!data[key]) {
        delete data[key];
      }
    });
    // 后端接口有对：举报类型和举报名字做校验，但是改版后前台表单没有这两项，所以这里做兼容处理
    data['report_theme'] = data['report_theme'] || ' ';
    data['informer'] = data['informer'] || ' ';
    data['type'] = data['type'] || 0;
    addreport(data).finally(() => {
      Object.assign(formData, initFormData());
    });
  },
  onConfirm(value) {
    state.value = value;
    state.showPicker = false;
  },
  onChangeArea(value) {
    let areaName = value.map(item => item && item.name);
    areaName = areaName.filter(item => !!item);
    formData.area_name = areaName.join(' / ');
    const areaCode = value
      .map(item => {
        if (item && item.code) {
          return item.code;
        }
      })
      .filter(item => item);
    formData.area_code = areaCode[areaCode.length - 1];
    state.showPicker = false;
  },
  clickUpload(fileData) {
    const {
      file: { name },
      content
    } = fileData;
    const dir = moment().format('YYYY/MM/');
    const filename = dir + md5(content) + upload.getExtname(name);
    fileData.filename = filename;
    upload.uploadHandle(fileData);
  },
  cancelSubmit() {
    Object.assign(formData, initFormData());
  },
  verifyUpdate(s) {
    // state.disabledSubmit = s.length !== 6;
    state.isVerifyCode = s.length === 6;
  },
  //
  onSourceChange(type) {
    console.log('change--', type);
    state.showType = type === 1;
  },
  onSourceTypeConfirm(col) {
    // console.log('col--', col);
    formData.source_type = col.value;
    state.selectedSourceTypeText = col.text;
    state.showSourceType = false;
  },
  // 同意声明：当同意声明并且填写过验证码才允许
  onAgree() {
    state.isAgree = !state.isAgree;
    // if (state.isVerifyCode && state.isAgree) {
    //   state.disabledSubmit = false;
    // } else {
    //   state.disabledSubmit = true;
    // }
    state.disabledSubmit = !state.isAgree;
  }
};
